import { ActionContext, ActionTree } from "vuex";
import { IAppState } from "./app.inteface";
import { IRootState, ILoadResponse, ISnackbar, DialogConfig, BlockerConfig, IStaff } from "@/interfaces";
import { Load } from "@/api";

type AppActionContext = ActionContext<IAppState, IRootState>;
type AppActionTree = ActionTree<IAppState, IRootState>;

export const actions: AppActionTree = {
  async load(context: AppActionContext): Promise<any> {
    try {
      context.commit("setLoading", true);
      const load: ILoadResponse = await Load();
      context.commit("setLoad", load);
      return load;
    } catch (e) {
      //
    } finally {
      context.commit("setLoading", false);
    }
  },
  setSnackbar(context: AppActionContext, snakbar: ISnackbar) {
    context.commit("setSnackbar", snakbar);
  },
  setToken(context: AppActionContext, token: string ) {
    context.commit("setToken", token);
  },
  setExpiredTokenDialog(context: AppActionContext, value: boolean ) {
    context.commit("setExpiredTokenDialog", value);
	},

	setDialog(context: AppActionContext, config: DialogConfig)
	{
		context.commit("setDialog", config);
	},

	setBlocker(context: AppActionContext, config: BlockerConfig)
	{
		context.commit("setBlocker", config);
	},

	refreshTimestampUsers(context: AppActionContext)
	{context.commit("refreshTimestampUsers"); },

	refreshTimestampInvoices(context: AppActionContext)
	{ context.commit("refreshTimestampInvoices"); },

	refreshTimestampCustomers(context: AppActionContext)
	{ context.commit("refreshTimestampCustomers"); },

	refreshTimestampStaff(context: AppActionContext)
	{ context.commit("refreshTimestampStaff"); },

	setStaffStatus(context: AppActionContext, staff: IStaff) {
		context.commit("setStaffStatus", staff); 
		context.commit("refreshTimestampStaff");
  },


};
